import type { TOC } from '@ember/component/template-only';

interface TooltipFooterSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const PrismTooltipFooter = <template>
  <div class="prism-tooltip-footer" ...attributes>
    <div class="prism-tooltip-footer__container">
      <p class="text-300--regular">
        {{yield}}
      </p>
    </div>
  </div>
</template> satisfies TOC<TooltipFooterSignature>;

export default PrismTooltipFooter;
